import { useLocationBySlug } from "@/data/queries/useLocationBySlug";
import { LocationSearch } from "@/components/LocationSearch";
import LandingTopBurgers from "@/components/LandingTopBurgers";

interface LandingTopRatedProps {
  locationSlug: string;
  onLocationChange: (slug: string) => void;
}

/**
 * Location-aware "top rated" social-proof box. Falls back to the global
 * ranking whenever we have no detected location or the location has no rows.
 */
export const LandingTopRated = ({ locationSlug, onLocationChange }: LandingTopRatedProps) => {
  const isGlobal = locationSlug === "world";
  const { data: location } = useLocationBySlug(isGlobal ? null : locationSlug);
  const heading = isGlobal ? "Top rated globally" : `Top rated in ${location?.name ?? "your area"}`;

  return (
    <section className="mt-16 md:mt-20 mx-auto w-full max-w-xl">
      <div className="rounded-2xl border border-border/60 bg-gradient-to-br from-primary/5 via-card to-card p-6 shadow-medium">
        <div className="flex flex-wrap items-center justify-between gap-3 mb-4">
          <h2 className="text-[11px] font-semibold uppercase tracking-[0.18em] text-foreground/70">
            {heading}
          </h2>
          <LocationSearch
            value={locationSlug}
            onValueChange={onLocationChange}
            className="h-8 text-xs"
          />
        </div>

        <LandingTopBurgers
          locationId={isGlobal ? null : location?.id ?? null}
          minCheckins={isGlobal ? 2 : 1}
        />

        <p className="mt-4 text-xs text-muted-foreground">
          Rankings are based on verified community ratings.
        </p>
      </div>
    </section>
  );
};

export default LandingTopRated;
